/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CommunityCommentDto } from '../../models/community-comment-dto';
import { CreateCommunityCommentDto } from '../../models/create-community-comment-dto';

export interface CommunityCommentControllerCreate$Params {
      body: CreateCommunityCommentDto
}

export function communityCommentControllerCreate(http: HttpClient, rootUrl: string, params: CommunityCommentControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<CommunityCommentDto>> {
  const rb = new RequestBuilder(rootUrl, communityCommentControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CommunityCommentDto>;
    })
  );
}

communityCommentControllerCreate.PATH = '/api/community-comments';
